"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 29 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M7.44629 8.68262H3.59082L2.78418 11H0.986328L4.74609 1.04688H6.29785L10.0645 11H8.25977L7.44629 8.68262ZM4.07617 7.28809H6.96094L5.51855 3.15918L4.07617 7.28809ZM18.6436 7.75977C18.5433 8.82161 18.1514 9.65104 17.4678 10.248C16.7842 10.8405 15.875 11.1367 14.7402 11.1367C13.9473 11.1367 13.2477 10.9499 12.6416 10.5762C12.04 10.1979 11.5752 9.66243 11.2471 8.96973C10.9189 8.27702 10.748 7.47266 10.7344 6.55664V5.62695C10.7344 4.68815 10.9007 3.861 11.2334 3.14551C11.5661 2.43001 12.0423 1.87858 12.6621 1.49121C13.2865 1.10384 14.0065 0.910156 14.8223 0.910156C15.9206 0.910156 16.8047 1.20866 17.4746 1.80566C18.1445 2.40267 18.5342 3.24577 18.6436 4.33496H16.9209C16.8389 3.61947 16.6292 3.10449 16.292 2.79004C15.9593 2.47103 15.4694 2.31152 14.8223 2.31152C14.0703 2.31152 13.4915 2.58724 13.0859 3.13867C12.6849 3.68555 12.4798 4.48991 12.4707 5.55176V6.43359C12.4707 7.50911 12.6621 8.32943 13.0449 8.89453C13.4323 9.45964 13.9974 9.74219 14.7402 9.74219C15.4193 9.74219 15.9297 9.58952 16.2715 9.28418C16.6133 8.97884 16.8298 8.4707 16.9209 7.75977H18.6436ZM28.0977 11H26.375V6.57715H21.9248V11H20.1953V1.04688H21.9248V5.18945H26.375V1.04688H28.0977V11Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;